import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tab, TabNav } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { DASHBOARD_TABS } from '../constants';
import { useDashboardUI } from '../context';

/**
 * Created / Templates.
 *
 * Separate from `DashboardListHeader` because it does not belong to the pinned
 * part of the page: the title and its action stay put while you scroll, the
 * tabs go away with the rest. Keeping them in the header meant they compressed
 * along with it and stayed on screen, which is not what a tab bar should do.
 *
 * `TabNav` + `Tab`, the underline bar Governance and Agentic Studio use for
 * page tabs. `ScrollTabs` is exported by the DS but used by neither repo, and
 * its horizontal-scroll rail buys nothing for two labels.
 */
const DashboardListTabs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('dashboards');
  const { activeTab } = useDashboardUI();

  const handleTabCreated = useCallback(() => navigate('/dashboards'), [navigate]);
  const handleTabTemplates = useCallback(() => navigate('/dashboards/templates'), [navigate]);

  return (
    <TabNav className="shrink-0" ariaLabel={t('header.title')}>
      <Tab size="sm" selected={activeTab === DASHBOARD_TABS.CREATED} onClick={handleTabCreated}>
        {t('tabs.created')}
      </Tab>
      <Tab size="sm" selected={activeTab === DASHBOARD_TABS.TEMPLATES} onClick={handleTabTemplates}>
        {t('tabs.templates')}
      </Tab>
    </TabNav>
  );
};

export default DashboardListTabs;
